import { Button, Alert } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "context";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";
import UploadComponent from "./uploadComponent";

const ParentComponent = () => {
	const authContext = useContext(AuthContext);
	const { type, istanceName, idIstance } = useParams();
	const [searchParams] = useSearchParams();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [documents, setDocuments] = useState([
		/*{
      id: 'doc1',
      required: true,
      label: 'Durc',
      status : 'toUpload',
      //url: 'https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',
      additionalInformation: [
        { id: 'expiration', type: 'date', value: '', required: true, label: 'Data di scadenza' },
        { id: 'info1', type: 'text', value: '', required: true, label: 'Emittente' },
        { id: 'info2', type: 'number', value: '', required: false, label: 'Codice DURC' },
        { id: 'info3', type: 'bool', value: false, required: false, label: 'Verificato' },

      ],
    },
    {
      id: 'doc10',
      required: false,
      label: 'Bho',
      status : 'toUpload',
      //url: 'https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',
      additionalInformation: [
        { id: 'expiration', type: 'date', value: '', required: true, label: 'Data di scadenza' },
        { id: 'info1', type: 'text', value: '', required: true, label: 'Emittente' },
        { id: 'info2', type: 'number', value: '', required: false, label: 'Codice DURC' },
        { id: 'info3', type: 'bool', value: false, required: false, label: 'Verificato' },

      ],
    },
    {
      id: 'doc2',
      required: true,
      label: 'Visura',
      status: 'approved',
      url: 'https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',
      additionalInformation: [
        { id: 'expiration', type: 'date', value: '', required: true, label: 'Data di scadenza' },
        { id: 'info1', type: 'text', value: '', required: true, label: 'Emittente' },
        { id: 'info2', type: 'number', value: '', required: true, label: 'Codice Visura' },
      ],
    },
    {
      id: 'doc3',
      required: false,
      status: 'rejected',
      rejectionReason: 'La data di scadenza non è valida',
      label: 'Patente muletto',
      url: 'https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',
      additionalInformation: [
        { id: 'info5', type: 'text', value: 'Default text', required: false, label: 'Emittente' },
        { id: 'expiration', type: 'date', value: '', required: true, label: 'Data di scadenza' },
      ],
    },
    {
      id: 'doc4',
      required: false,
      status: 'rejectedDone',
      label: 'Patente macchina',
      additionalInformation: [
        { id: 'info5', type: 'text', value: 'MULATTI', required: false, label: 'Emittente' },
        { id: 'expiration', type: 'date', value: '2023-12-31', required: true, label: 'Data di scadenza' },
      ],
    },*/
	]);

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	function fecthData() {
		setLoading(true);
		if (type === "supplier") {
			// Controlla se c'è un supplier_id nei query params (security manager)
			const supplierIdFromQuery = searchParams.get("supplier_id");
			const supplierFromLocalStorage = localStorage.getItem("supplier");

			// Recupera anche da sessionStorage per gli admin
			const supplierFromSession = sessionStorage.getItem('selectedSupplier');
			const supplierIdFromSession = supplierFromSession ? JSON.parse(supplierFromSession).id : null;

			const supplierIdToUse = supplierIdFromQuery || supplierFromLocalStorage || supplierIdFromSession;

			// Validazione: se è null, redirect alla pagina di selezione
			if (!supplierIdToUse) {
				setLoading(false);
				handleSetNotification(
					"Seleziona un fornitore prima di gestire i documenti",
					"warning"
				);
				setTimeout(() => {
					navigate('/security-document-supplier/');
				}, 1500);
				return;
			}

			// Se c'è un supplier_id dalla query o session, carica anche le info del fornitore
			if (supplierIdFromQuery || supplierIdFromSession) {
				apiService
					.get("/suppliers-management", { supplier_id: supplierIdToUse }, {})
					.then((response) => {
						if (response) {
							setSupplierInfo(response);
						}
					})
					.catch((error) => {
						console.error("Error fetching supplier info:", error);
					});
			}

			apiService
				.get("/get-documents", { supplier_id: supplierIdToUse }, {})
				.then((response) => {
					setLoading(false);
					if (response) {
						setDocuments(response);
					}
				})
				.catch((error) => {
					setLoading(false);
					handleSetNotification(
						"Errore durante la chiamata al server, codice d'errore #08514262429906",
						"error"
					);
				});
		} else if (type === "user" && idIstance) {
			apiService
				.get("/get-documents", { user_id: idIstance, external: "true" }, {})
				.then((response) => {
					if (response) {
						setLoading(false);
						setDocuments(response);
					}
				})
				.catch((error) => {
					setLoading(false);
					handleSetNotification(
						"Errore durante la chiamata al server, codice d'errore #085146273617262429906",
						"error"
					);
				});
		} else if (type === "user-internal" && idIstance) {
			apiService
				.get("/get-documents", { user_id: idIstance, external: "false" }, {})
				.then((response) => {
					if (response) {
						setLoading(false);
						setDocuments(response);
					}
				})
				.catch((error) => {
					setLoading(false);
					handleSetNotification(
						"Errore durante il caricamento dei documenti",
						"error"
					);
				});
		}
	}

	useEffect(() => {
		if (type) {
			fecthData();
		}
	}, [type, idIstance]);

	const handleSave = (updatedDocuments) => {
		console.log("Dati salvati:", updatedDocuments);
		// Per user-internal, il tipo API è "user" (usa SecurityAreaUser)
		const apiType = type === "user-internal" ? "user" : type;
		apiService.post("/upload-documents/", {}, { files: updatedDocuments, type: apiType }).then(
			(response) => {
				if (response) {
					handleSetNotification("Documenti caricati con successo", "success");
					fecthData();
				}
			},
			(error) => {
				handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error");
			}
		);
	};

	return (
		<>
			<DashboardLayout>
				{authContext?.hasAuth("UPSERT_DOCUMENTS_SUPPLIER") ? (
					<>
						<DashboardNavbar />
						<div>
							<center>
								<MDTypography variant="h3" sx={{ mt: 5, mb: 3 }}>
									GESTIONE DOCUMENTI{" "}
									{type === "supplier" ? (supplierInfo ? supplierInfo.name.toUpperCase() : "AZIENDA") : istanceName?.toUpperCase()}{" "}
								</MDTypography>

								{/* Alert per security manager */}
								{supplierInfo && (
									<Alert severity="info" sx={{ maxWidth: 600, mb: 3 }}>
										Stai caricando documenti per <strong>{supplierInfo.name}</strong>.
										I documenti richiederanno approvazione.
									</Alert>
								)}

								<Button
									onClick={() => {
										if (type === "supplier") {
											navigate("/security-document-supplier/");
										} else if (type === "user-internal") {
											navigate("/security-document-internal-user/");
										} else {
											navigate("/security-document-supplier-user/");
										}
									}}
									type="submit"
									variant="contained"
									component="span"
									sx={{
										backgroundColor: "#514f4f",
										color: "white!important",
										mb: 2,
										width: "220px",
										height: "50px",
										fontSize: "16px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "8px",
									}}
								>
									Indietro
								</Button>
							</center>
							{!loading ? (
								<UploadComponent
									documents={documents}
									setDocuments={setDocuments}
									idIstance={idIstance}
									onSave={handleSave}
								/>
							) : (
								<center>
									<CircularProgress size={120} sx={{ marginTop: "250px", color: "#2b84ea" }} />
								</center>
							)}
						</div>
					</>
				) : (
					<MDBox mt={8}>
						<MDAlert color="error">Non hai i permessi per visualizzare questa pagina</MDAlert>
					</MDBox>
				)}
			</DashboardLayout>
		</>
	);
};

export default ParentComponent;
